import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
export function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  const toggleOpen = () => {
    const newState = !isOpen;
    setIsOpen(newState);
    if (newState && typeof window !== 'undefined' && window.fbq) {
      window.fbq('trackCustom', 'FAQInteraction', {
        question
      });
    }
  };
  return <div className="bg-white border border-slate-200 rounded-xl overflow-hidden transition-all duration-200 hover:border-slate-300 shadow-sm" data-id="element-139">
      <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={toggleOpen} data-id="element-140">
        <span className="font-semibold text-slate-900 pr-4 text-lg" data-id="element-141">
          {question}
        </span>
        <ChevronDown className={`w-5 h-5 text-slate-400 transition-transform duration-300 flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-142" />
      </button>
      <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-143">
        <p className="text-slate-600 leading-relaxed" data-id="element-144">{answer}</p>
      </div>
    </div>;
}